import type { PropsWithChildren } from 'react';
import React from 'react';

interface RequestAnimationFrameProps extends PropsWithChildren {
  onFrame: () => void;
}

export default class RequestAnimationFrame extends React.Component<RequestAnimationFrameProps> {
  isOnFrameRegistered: boolean;
  animationFrameId: number;

  constructor(props) {
    super(props);

    this.registerOnFrame = this.registerOnFrame.bind(this);
    this.unregisterOnFrame = this.unregisterOnFrame.bind(this);
    this.onFrame = this.onFrame.bind(this);

    this.isOnFrameRegistered = false;

    this.animationFrameId = NaN;
  }

  componentDidMount() {
    this.registerOnFrame();
  }

  componentWillUnmount() {
    this.unregisterOnFrame();
  }

  registerOnFrame() {
    if (this.isOnFrameRegistered) {
      return;
    }

    this.isOnFrameRegistered = true;
    this.onFrame();
  }

  unregisterOnFrame() {
    if (!this.isOnFrameRegistered) {
      return;
    }

    this.isOnFrameRegistered = false;
    window.cancelAnimationFrame(this.animationFrameId);
  }

  onFrame() {
    this.props.onFrame();

    if (this.isOnFrameRegistered) {
      this.animationFrameId = window.requestAnimationFrame(this.onFrame);
    }
  }

  render() {
    return this.props.children;
  }
}
